import React from 'react';
import {
  Button,
  ButtonProps,
  useTheme,
  alpha,
  CircularProgress,
} from '@mui/material';

interface PrimaryButtonProps extends ButtonProps {
  loading?: boolean;
  pulse?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  loading = false,
  pulse = false,
  disabled,
  sx,
  ...props
}) => {
  const theme = useTheme();
  const isDisabled = disabled || loading;

  const buttonStyles = {
    borderRadius: '12px',
    textTransform: 'none' as const,
    fontWeight: 600,
    fontSize: '0.95rem',
    fontFamily: 'Inter, sans-serif',
    px: { xs: 3, md: 4 },
    py: { xs: 1.2, md: 1.5 },
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    minWidth: '120px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
      boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)',
      transform: 'translateY(-2px)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
    '&.Mui-disabled': {
      opacity: 0.6,
      transform: 'none',
      boxShadow: 'none',
    },
    ...(pulse && {
      animation: 'pulse 2s infinite',
    }),
    ...sx,
  };

  return (
    <Button
      {...props}
      disabled={isDisabled}
      sx={buttonStyles}
      startIcon={loading ? <CircularProgress size={18} color="inherit" /> : props.startIcon}
    >
      {loading ? 'Cargando...' : children}
    </Button>
  );
};

export default PrimaryButton; 